import React, { Component } from 'react';
import LoginForm from 'components/forms/login/LoginForm';
import { Row, Col, Modal, Icon, Progress, Button } from 'antd';
import { REST } from 'utils/reqUtils';
import PasswordUpdate from 'containers/PasswordUpdate';
import LoginCode455 from 'components/login/code/LoginCode455';
import LoginCode457 from 'components/login/code/LoginCode457';
import LoginCode403 from 'components/login/code/LoginCode403';
import LoginCode456 from 'components/login/code/LoginCode456';

const
{ STATUS } = REST,
styleProps = {
    row: {
        type: "flex",
        justify: "space-around",
        align: "middle",
        style: {
            textAlign: 'center',
            overflow: 'auto',
            height: '110px'
        }
    },
    col: {
        span: 24,
        style: {
            display: 'table',
            height: '100%',
            width: '100%'
        }
    },
    span: {
        style: {
            display: 'table-cell',
            verticalAlign: 'middle'
        }
    },
    containerDiv: {
        style: {
            textAlign: 'center'
        }
    },
    textDiv: {
        style: {
            fontSize: 14,
            fontWeight: 'bold'
        }
    },
    indicatorDiv: {
        style: {
            marginTop: '10px'
        }
    }
}

class View extends Component {
    render() {
        const { children, modalProps, formProps } = this.props;
        return (
            <Modal {...modalProps}>
                <Row {...styleProps.row}>
                    <Col {...styleProps.col}>
                        <span {...styleProps.span}>
                            {children}
                        </span>
                    </Col>
                </Row>
            </Modal>
        )
    }
}

export default class Login extends Component {
    constructor(props) { super(props); }

    render() {
        const
        p = this.props,
        { services, controls } = p;

        switch(p.request.status) {
            case STATUS.NONE: return (
                <Modal {...p.modalProps}>
                    <LoginForm {...p.formProps}/>
                </Modal>
            );

            case STATUS.PENDING: return (
                <View {...this.props}>
                    <div>
                        <div {...styleProps.textDiv}>{'Attempting to log in...'}</div>
                        <div style={{ fontStyle: 'italic' }}>
                            {'Please wait...'}
                        </div>
                        <div {...styleProps.indicatorDiv}>
                            <Icon type='loading' style={{ fontSize: 40 }} />
                        </div>
                    </div>
                </View>
            );

            case STATUS.SUCCESS: return (
                <View {...this.props}>
                    <div>
                        <div {...styleProps.textDiv}>
                            {'Log in successful!'}
                        </div>
                        <div style={{ fontStyle: 'italic' }}>
                            {'Please wait...'}
                        </div>
                        <div {...styleProps.indicatorDiv}>
                            <Progress type='circle' width={45} percent={100}/>
                        </div>
                    </div>
                </View>
            );

            case STATUS.FAILURE:
                switch(p.request.code) {
                    case 403: return (
                        <View {...this.props}>
                            <LoginCode403 styleProps={styleProps} controls={controls} />
                        </View>
                    );

                    case 455: return (
                        <View {...this.props}>{
                            p.showPasswordUpdate
                                ? <PasswordUpdate controls={p.controls} />
                                : <LoginCode455 styleProps={styleProps} services={services} reset={p.reset} />
                        }</View>
                    );

                    case 456: return (
                        <View {...this.props}>
                            <LoginCode456 styleProps={styleProps} controls={controls} />
                        </View>
                    );

                    case 457: return (
                        <View {...this.props}>
                            <LoginCode457 styleProps={styleProps} />
                        </View>
                    );

                    default: return (
                        <View {...this.props}>
                            <div>
                                <div {...styleProps.textDiv}>{'Log in failed...'}</div>
                                <div style={{ fontStyle: 'italic' }}>
                                    {'Please try again...'}
                                </div>
                                <div {...styleProps.indicatorDiv}>
                                    <Progress type='circle' width={45} percent={100} status='exception'/>
                                </div>
                            </div>
                        </View>
                    );
                }
        }
    }
}
